/**
 * Compile-time literal union of all valid Company field IDs.
 *
 * Derived from the `satisfies`-typed field maps in `./fields/*.ts`.
 * Used to narrow `SavedViewConfig.visibleColumns` so typos in saved views
 * are caught by `tsc`.
 */
import { companyBasicFields } from "./fields/company-fields-basic";
import { companyContactCommercialFields } from "./fields/company-fields-contact-commercial";
import { companyLocationFields } from "./fields/company-fields-location";
import { companyMetadataFields } from "./fields/company-fields-metadata";
import { companyExtendedFields } from "./fields/company-fields-extended";
import { companyDerivedFields } from "./fields/company-fields-derived";

export const COMPANY_FIELDS = {
  ...companyBasicFields,
  ...companyContactCommercialFields,
  ...companyLocationFields,
  ...companyMetadataFields,
  ...companyExtendedFields,
  ...companyDerivedFields,
};

/** Literal union of every valid company field id. */
export type CompanyFieldId = keyof typeof COMPANY_FIELDS;
